/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 *
 *
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.27.0
 */

import styled from 'styled-components';

export const ProductOfferingsStepConfirmationTooltipText = styled.span`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fit, minmax(0, 1fr));
    row-gap: 5px;
`;
